import { Plus } from 'lucide-react';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@verclam/ui-kit';

/** Leaf action: opens the empty type editor. */
const NewSubjectTypeButton: React.FC = () => {
	const navigate = useNavigate();

	const handleClick = React.useCallback(() => {
		navigate('/administration/subject-types/new');
	}, [navigate]);

	return <Button type="button" label="Nouveau type" icon={<Plus size={16} />} onClick={handleClick} />;
};

export default NewSubjectTypeButton;
